import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const LibraryServices = () =>{
  
  return (
    <div className="Services">
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="./assets/img/innerbanner/library-services.jpg" alt=""/>
      </section>
     
      <section  className="research-box-area">
           <Container>
           <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/CollaborativeWorkingAndLearningSpaces">
                  Explore
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>Library Services</BreadcrumbItem>
              </Breadcrumb>
              <div className='information-content'>
                <h2>Library Services</h2>
                <p>Habib University’s library team aims to provide students with adequate facilities for learning with passion. With a range of library and learning services available, it creates an environment that supports teaching, learning, and research. The library provides a stimulating user-centered environment, learning spaces, and customer services supported by digital technologies.</p>
              </div>
              <Row className="ParentBorderBox">
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <div>
                        <h5>Borrowing and Renewal Services</h5>
                        <p>We extend borrowing services to the HU community members (faculty, students, and staff) as per borrowing privileges, rules, and policies. Materials can be borrowed and returned to the circulation desks located on the first floor. The materials include course books, course packs, reference books, and academic journals. It is important to keep in mind that any material borrowed from the library is subject to recall. The renewals or re-issuance of materials can be done twice.</p>
                      </div>
                      
                    </div>
                  </Col>
                  
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box ">
                      <div>
                        <h5>Information Literacy Workshops and Library Orientation Sessions</h5>
                        <p>The HU library team organizes orientation sessions at the beginning of each semester to provide in-depth knowledge about the library and its services. Furthermore, information literacy workshops are also organized for the students to facilitate them to strengthen their literature searching, citation management, and research skills. The information literacy workshops are held in small groups or in the form of in-class sessions. Contact <a href="tel:+9221111042242,;ext=5524">5524</a> or send an e-mail request to <a href="mailto:library@habib.edu.pk">library@habib.edu.pk</a></p>
                      </div>
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box">
                        <h5>Online Literature Searching for assignments and projects</h5>
                        <p>Library Staff helps HU community members through one-on-one training or workshops and facilitates them in conducting a literature search on a particular subject or topic and may facilitate in:</p>
                        <ul className="research-box-list"> 
                          <li>Sharing details of the right resources for your search.</li>
                          <li>Fine-tuning your search strategies.</li>
                          <li>Identifying materials closely related to the research topic.</li>
                          <li>Arranging and supplying full-text articles, if required.</li>
                          <li>Responding to queries related to accessibility and delivery.</li>
                        </ul>
                    </div>
                    
                  </Col>
                  
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <div>
                        <h5>Help desk</h5>
                        <p>Patrons may ask for IT Support related to printing, enabling internet on digital devices, the self-service portal, and the campus management system at the Information Commons ground floor. Call <a href="tel:+9221111042242;ext=6343">6343</a> for further assistance.</p>
                      </div>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                    <div className="research-box">
                      <div>
                        <h5>Inter-Library Loan</h5>
                        <p>In case the HU community needs an item not available in the existing library collection (print book or online article), the library will attempt to borrow it from another library within the city through an ‘Inter-Library Loan’ arrangement. Call <a href="tel:+9221111042242;ext=5524">5524</a> or <a href="tel:+9221111042242;ext=5523">5523</a> for further assistance or e-mail at <a href="mailto:illp@habib.edu.pk">illp@habib.edu.pk</a>.</p>
                      </div>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box">
                      <div>
                        <h5>Online Chat Reference</h5>
                        <p>For immediate or urgent queries, patrons can contact the library team using the online chat reference service available at <a href="mailto:library.habib.edu.pk">library</a>, from 9:00 a.m. to 5:00 p.m.</p>
                      </div>
                      
                    </div>
                    
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  
                  <div className="research-box">
                      <div>
                        <h5>Reference Services</h5>
                        <p>Our team is available to provide proactive reference services from 9.00 a.m. to 6.30 p.m. Call <a href="tel:+9221111042242;ext=7105">7105</a> or <a href="tel:+9221111042242;ext=5524">5524</a> for further assistance.</p>
                      </div>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="bord">
                  <div className="research-box">
                    <h5>Library Forms</h5>
                    <ul>
                      <li>
                          <a target="_blank" href="https://habibuniversity.sharepoint.com/sites/Staff/Pages/Library-Resource-Request.aspx" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            Book/s Purchase Request Form
                          </a>
                      </li>
                      <li>
                        <a target="_blank" href="https://habibuniversity.sharepoint.com/sites/Student/hira-metadata-form" className="link-btn">
                          <img src="./assets/img/link-icon.svg" alt=""/>
                          FYP Submission Form
                        </a>
                      </li>
                      <li>
                          <a target="_blank" href="https://tinyurl.com/mrx5hcbb" className="link-btn">
                            <img src="./assets/img/link-icon.svg" alt=""/>
                            Patron Registration
                          </a>
                      </li>
                    </ul>
                  </div>
                  </Col>
              </Row>
           </Container>
      </section>
     
    </div>
  );
}
export default LibraryServices;